import reloadWarmupsCountOnAllParts from "../reload-warmups-count-on-all-parts";

export default function (context) {
    const $context = $(context);
    const $warmupContainer = $context.find('.warmups-list-part');
    const $warmupImportButton = $context.find('.import-warmups-from-file');

    // Clear warmup images if exists in container
    $warmupContainer.find('[data-warmup-item-image]').remove();
    $warmupImportButton.removeClass('hide');

    reloadWarmupsCountOnAllParts();
}
